<template>
    <wc-button
        class="btn btn-danger"
        :disabled="isDisabled"
        v-on:click="onClick"
    >
        {{ label }}
    </wc-button>
</template>

<script>
import axios from "axios";
import "@25sprout-internal/wc-button";
import { config, apiPath } from "@backstagex/core/src/config";
import { abstractField } from "@backstagex-vue-form-generator/core";
export default {
    mixins: [abstractField],
    props: ["schema", "model", "disabled"],
    data: function () {
        return {
            isDisabled: false,
            label: "解除歸附",
        };
    },
    created: function () {
        this.isDisabled = this.$route.name === "create";
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;
            if (this.$route.name === "create") return;
            var confirm = window.confirm("確認解除此筆歸附資料？");
            if (confirm) {
                axios
                    .delete(
                        config.apiHost +
                            "/api/bscore/" +
                            this.$route.params.menuItemKey +
                            "/" +
                            this.$route.params.id
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            alert("解除歸附成功");
                            this.$router.go(-1);
                        } else {
                            alert("解除歸附失敗");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
};
</script>